import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { TransportIncidentView } from '../models/transport-incident-view.model';
import { TransportIncidentService } from './transport-incident.service';
import { ApiProviderService } from './api-provider.service';
import { ApplicationConfigService } from './application-config.service';
import { Observable } from 'rxjs';
import { createRequestOption } from '../app/shared/util/request-util';
import { map } from 'rxjs/operators';

export type EntityResponseType = HttpResponse<TransportIncidentView>;
export type EntityArrayResponseType = HttpResponse<TransportIncidentView[]>;

@Injectable({ providedIn: 'root' })
export class TransportIncidentExtendedService extends TransportIncidentService {
  constructor(protected override apiProvider: ApiProviderService, protected override applicationConfigService: ApplicationConfigService) {
    super(apiProvider, applicationConfigService);
  }

  override query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider
      .get<TransportIncidentView[]>(this.resourceUrl, { params: options, observe: 'response' })
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }
}
